module.exports = __webpack_public_path__ + "catalog/items/bathroom/shower/shower.svg";